<template lang="pug">
  .d-footer
    .top
      .left
        img(src="~assets/footer/logo.png")
      .center
        .item
          .title
            router-link(to="/index")
              span 关于懂窝
          .lable(@click="clickLable('brand-desc')")
            router-link(to="/index?scrollEl=brand-desc")
              span 品牌介绍
          .lable(@click="clickLable('module3')")
            router-link(to="/index?scrollEl=module3")
              span 产品介绍
          .lable(@click="clickLable('module5')")
            router-link(to="/index?scrollEl=module3")
              span 合作工厂
          .lable(@click="clickLable('module12')")
            router-link(to="/index?scrollEl=module10")
              span 品牌合作伙伴
        .item
          .title
            router-link(to="/serviceRules")
              span 服务政策
          .lable(@click="clickLable('module5')")
            router-link(to="/index?scrollEl=module5")
              span 服务特色
          .lable
            router-link(to="/serviceRules?currentTab=1")
              span 配送说明
          .lable
            router-link(to="/serviceRules?currentTab=2")
              span 售后服务
          .lable
            router-link(to="/serviceRules?currentTab=3")
              span 常见问题
        .item
          .title
            router-link(to="/contactUs")
              span 联系我们
          .lable
            router-link(to="/contactUs?currentTab=1")
              span 合作咨询
          .lable
            router-link(to="/contactUs?currentTab=2")
              span 招聘信息
      .right
        .cont
          img(src="~assets/footer/qrCode.jpg")
          p 微信公众号
    .bottom 上海素造网络科技有限公司版权所有  |  沪ICP备19016235号  |   © Copyright 2019 All Rights Reserved
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    clickLable(el) {
      this.$bus.$emit('scrollTopFn',el)
    }
  },
};
</script>

<style lang="sass" scoped>
@import 'config'
.d-footer
  width: 100%
  height: r(449)
  background: #000001
  padding-top: r(78)
  font-family: PingFangSC-Semibold
  .top
    width: 100%
    box-sizing: border-box
    display: flex
    justify-content: space-between
    text-align: center
    .left
      width: r(554)
      height: r(202)
      box-sizing: border-box
      border-right: 1px solid #808182
      img
        display: block
        margin-left: r(180)
        width: r(288)
    .center
      width: r(520)
      display: flex
      justify-content: space-between
      .item
        .title
          padding-bottom: r(11)
          font-size: r(20)
          border-bottom: 1px solid #404142
          margin-bottom: r(14)
          span
            color: #FFFFFF
        .lable
          font-size: r(19)
          line-height: r(37)
          span
            color: #FFFFFF
    .right
      width: r(580)
      height: r(202)
      box-sizing: border-box
      border-left: 1px solid #808182
      .cont
        margin-left: r(142)
        width: r(116)
        img
          width: 100%
        p
          margin-top: r(10)
          width: 100%
          font-size: r(18)
          color: #FFFFFF
          text-align: center
  .bottom
    margin: r(72) auto 0
    width: r(1370)
    height: r(96)
    font-family: PingFangSC-Regular
    font-size: r(20)
    color: #ffffff
    text-align: center
    line-height: r(96)
    border-top: 1px solid #808182
</style>



// WEBPACK FOOTER //
// footer.vue?77f57170